module.exports = __webpack_public_path__ + "media/homepage/weekly-insights-80d74992.jpg";